import React, { useEffect } from 'react'
// import useNewItemChange from '../../EHR Settings/Templates/OpenTemplate/FormBuilder/hooks/useNewItemChange';
import { Separator } from '../../../../../../../../../EHR/utils/utils';

// Viewer Component for Displaying the Checklist
const MultiChoice = ({ item, setItem, activeAccordion, isGroupNote, ...props }) => {

    const selectedOptions = item.selectedOptions?.split(Separator).length > 0
        ? item.selectedOptions.split(Separator).map(optStr => {
            const hasSelected = optStr.includes("(D)");
            const baseLabel = optStr.split("(D)")[0].split("[")[0];

            const metaMatch = optStr.match(/\[(.*?)\]/);
            let textResponse = "false";
            let hintText = "";
            let value = "";

            if (metaMatch) {
                const parts = metaMatch[1].split("|");
                parts.forEach(p => {
                    if (p.startsWith("TR=")) textResponse = p.split("=")[1];
                    if (p.startsWith("hintText=")) hintText = p.split("=")[1].replace(/'/g, "");
                    if (p.startsWith("value=")) value = p.split("=")[1].replace(/'/g, "");
                });
            }

            return {
                content: baseLabel,
                checked: hasSelected,
                textResponse: textResponse,
                hintText: hintText,
                value: value
            };
        })
        : [];
    const checkedOptions = selectedOptions.filter(opt => opt?.checked);
    // console.log("selectedOptionsmulticchoice", selectedOptions,"checkedOptions",checkedOptions)
    return (
        <div className="d-flex gap-10">
            <div className="ar-form-counter flex-center">
                <p className='text text-black'>{props?.itemCount}</p>
            </div>
            <div className="d-flex flex-column gap-6">
                <label htmlFor="" className="heading fs-13">
                    {/* {item.content} */}
                    {item.IsRepeated === 'true' && item.IsGroupEncounter === 'true' && isGroupNote ? item.PatientName + ' - ' + item.content : item.content}
                </label>
                {/* Multichoice */}
                <div className="d-flex flex-column gap-1">
                    {checkedOptions.length > 0 ? (
                        checkedOptions.map((option, index) => (
                            <div key={index} className="d-flex gap-1">
                                <p className='text'>{option.content}</p>

                                {option.textResponse === "true" && option.value && (
                                    <p className="text">- {option.value}</p>
                                )}

                                {/* {index !== checkedOptions.length - 1 && ', '} */}
                            </div>
                        ))
                    ) : (
                        <p className="text">N/A</p>
                    )}
                </div>

                {/* <div className="d-flex align-items-center gap-1">
                {selectedOptions.length > 0 &&
                    selectedOptions.map((option, index) => (
                        <>
                            {selectedOptions && selectedOptions[index]?.checked &&
                                <div className="d-flex gap-1 align-items-center text fs-14">
                                    {option.content}
                                    {option?.checked && option.textResponse === "true" && (
                                        <p className="text fs-14">{option.value ? `- ${option.value}` : <></>}</p>
                                    )}
                                    {index !== selectedOptions.length - 1 && selectedOptions.length > 1 && ', '}
                                </div>}
                        </>))}
                {selectedOptions?.every(it => it.checked === false) && <p className="text fs-14">N/A</p>}
            </div> */}

            </div>
        </div>
    );
};

export default MultiChoice;